import styled from "styled-components";
import {
  fontWeightBold,
  h3Regular,
} from "../../../../../../../../components/typography/MuiTypography.style";
import { COLORS } from "../../../../../../../../styles/constants.style";

export const NewDeliverableWrapper = styled.div`
  padding: 0px 16px 16px;

  .deliverable-name {
    background-color: ${COLORS.cirrus_white};
    position: relative;
  }

  .manage-locale-link {
    ${h3Regular}
    ${fontWeightBold}
    line-height: 20px;
    position: absolute;
    right: 0px;
    top: 0px;
    text-decoration: underline;
    text-underline-offset: 4px;
    color: ${COLORS.primary_light_blue};
  }
`;
